import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const setManagedAIProviderDisabled = mutator({
  schema: z.object({ disabled: z.boolean() }),
  resolve: {},
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    if (args.disabled) {
      const active = await tx.run(
        zql.aiProviders.where("tenantId", ctx.tenantId).where("active", true)
      );
      if (active.length === 0) {
        throw userFacingError(
          "Set another AI provider as the default before disabling the managed provider"
        );
      }
    }
    const now = Date.now();
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      managedAiProviderDisabledAt: args.disabled ? now : null,
      updatedAt: now,
    });
  },
});
